export const comparisonModes = {
  IS: 'is',
  IS_NOT: 'is not',
  UP_TO_STATUS: 'up to status',
  FROM_STATUS: 'from status',
  EQUAL: 'equal',
  NOT_EQUAL: 'not_equal',
  EXACTLY: 'exactly',
  SHOW_ALL: 'show-all',
  CONTAINS: 'contains',
  LESS_THAN: 'less_than',
  GREATER_THAN: 'greater_than',
  LESS_THAN_OR_EQUAL: 'less_than_or_equal',
  GREATER_THAN_OR_EQUAL: 'greater_than_or_equal',
  CURRENT_USER: 'current-user',
  USER: 'user',
  TRUE: 'true',
  FALSE: 'false',
}

export const InsightsStaticColumns = {
  NAME: 'name',
  SELECTED_PERIOD: 'selectedPeriod',
} as const

export const filters = {
  BOOKYEAR_END: 'BookyearEnd',
  COMPANY_DATA: 'CompanyData',
  COMPANY_GROUPS: 'CompanyGroups',
  FOLLOW_COMPANIES: 'FollowCompanies',
  FORMULA: 'Formula',
  PERIOD_LOCKED: 'PeriodLocked',
  PULSE_WORKFLOW_PROGRESS: 'PulseWorkflowProgress',
  PULSE_WORKFLOW_STATUS: 'PulseWorkflowStatus',
  RECONCILIATION_RESULT: 'ReconciliationResult',
  SUBMISSION_DATA: 'SubmissionData',
  WORKFLOW_PROGRESS: 'WorkflowProgress',
  WORKFLOW_SHARING_STATUS: 'WorkflowSharingStatus',
  WORKFLOW_STATUS: 'WorkflowStatus',
  WORKFLOW_USAGE: 'WorkflowUsage',
} as const

export const RIGHT_ALIGN_FILTER_TYPES = [
  filters.FORMULA,
  filters.RECONCILIATION_RESULT,
]

export const SLOW_FILTERS = [
  filters.WORKFLOW_PROGRESS,
  filters.FORMULA,
  filters.RECONCILIATION_RESULT,
]
